const binding = { modules: {}, dataActions: {} };

    (binding.modules['scroll-into-view'] = {
        c: () => require('partner/modules/scroll-into-view/scroll-into-view.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'scroll-into-view',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/scroll-into-view'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|scroll-into-view|scroll-into-view'] = {
                c: () => require('partner/modules/scroll-into-view/scroll-into-view.view.tsx'),
                cn: '__local__-__local__-scroll-into-view'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };